var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table-shared',{attrs:{"headers":_vm.headers,"loading":_vm.loading,"items":_vm.computedInfo,"height":"","perPage":100,"hide-footer":true}})}
var staticRenderFns = []

export { render, staticRenderFns }